var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPliLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 23,
    viewBox: "0 0 48 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo/Acronym",
    clipPath: "url(#clip0_22046_162669)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.32399 15.9003V22.9584H0.00195312V0.00187041C0.00195312 0.00187041 3.11382 -0.0122257 4.64128 0.00187041C8.14365 0.0340901 11.6562 -0.068611 15.1464 0.148872C20.5931 0.485165 22.2813 4.82878 21.8582 8.71326C21.3721 13.2643 18.7321 15.7049 14.1111 15.8842C11.8982 15.9728 7.32399 15.9003 7.32399 15.9003ZM7.37686 10.9082C7.37686 10.9082 10.4094 10.9525 11.8901 10.8961C13.5396 10.8317 14.4894 9.78255 14.5484 8.08901C14.6074 6.39546 13.7857 5.22951 12.126 5.09057C10.5721 4.96169 7.37686 5.06439 7.37686 5.06439V10.9082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M39.2887 17.2476V22.9585H23.0928V0.00604248H30.3396V17.2476H39.2887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M47.984 0.00604248H40.7881V22.9585H47.984V0.00604248Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22046_162669"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 22.9565,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPliLogo);
export default __webpack_public_path__ + "static/media/PLILogo.acd13a827dce3d254e9136289301dd68.svg";
export { ForwardRef as ReactComponent };